<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation2
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px; padding-left:10px;">
            <el-button type="text">
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.industry"
              placeholder="请输入卷烟所属工业"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.name"
              placeholder="请输入卷烟商品名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="2">
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table2
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @add="addFun"
        @edit="editFun(arguments)"
        @stop="stopFun(arguments)"
        @start="startFun(arguments)"
        @view="viewFun(arguments)"
        @dblclick="viewFun(arguments)"
        @export="batchExport(masterList)"
      />
    </div>

    <!-- 新增 修改-->
    <add-edit-view-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogAddEditTitle"
      :dialog-visible.sync="dialogAddEditVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation2 from '@/components/TableOperation2'
// 列表设置tableKeyMixin
import tableOperationMixin2 from '@/mixin/tableOperationMixin2'
// 导出 batchExportMixin
import batchExportMixin2 from '@/mixin/batchExportMixin2'
// 自定义Table
import CustomTable2 from '@/components/CustomTable2'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin2 from '@/mixin/tableCustomMixin2'
// 新增 修改
import addEditViewDialog from './components/addEditViewDialog'
// API
import { loadTobaccoInfoListDataApi, exportTobaccoInfoListDataApi, updateTobaccoInfoStatusApi } from '@/api/v2/tobaccoInfo'

export default {
  name: 'TobaccoInfo',
  components: {
    CustomTable2,
    TableOperation2,
    addEditViewDialog
  },
  mixins: [tableCustomMixin2, tableOperationMixin2, batchExportMixin2],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'base_tobacco_info_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['tobacco_info_add'],
            prop: 'add',
            label: '新增',
            method: 'add'
          },
          {
            permissionSigns: ['tobacco_info_edit'],
            prop: 'edit',
            label: '修改',
            method: 'edit'
          },
          {
            permissionSigns: ['tobacco_info_del'],
            prop: 'start',
            label: '启用',
            method: 'start'
          },
          {
            permissionSigns: ['tobacco_info_del'],
            prop: 'stop',
            label: '停用',
            method: 'stop'
          },
          {
            permissionSigns: ['tobacco_info_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['tobacco_info_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          // 页数
          page: 1,
          // 每页条数
          limit: 50,
          // 右键筛选字段
          contextMenuWrap: [],
          // 排序字段
          sortProp: '',
          // 排序类型
          sortOrder: '',
          // 查询条件
          industry: '',
          name: ''
        }
      },
      // 选中的单据ID
      id: null,
      dialogAddEditVisible: false,
      dialogAddEditTitle: '',
      eventType: ''
    }
  },
  created () {
    let _this = this;
    // 初始化主列表Table列
    _this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'industry', label: '所属工业', width: 120 },
      { prop: 'brand', label: '品牌', width: 120 },
      { prop: 'name', label: '名称', width: 170 },
      { prop: 'unit', label: '单位', width: 90 },
      { prop: 'typeValue', label: '价类', filterColumn: 'type', filterValue: 'type', filterArray: [{ label: '一类烟', value: 1 }, { label: '二类烟', value: 2 }, { label: '三类烟', value: 3 }, { label: '四类烟', value: 4 }, { label: '五类烟', value: 5 }, { label: '无价类', value: 0 }], width: 90 },
      { prop: 'wholesalePrice', filterColumn: 'wholesale_price', label: '批发价', width: 100 },
      { prop: 'retailPrice', filterColumn: 'retail_price', label: '零售价', width: 100 },
      { prop: 'statusValue', label: '状态', filterColumn: 'status', filterValue: 'status', filterArray: [{ label: '启用', value: 1 }, { label: '停用', value: 2 }], width: 90 },
      { prop: 'remark', label: '备注', minWidth: 150 },
      { prop: 'operatorName', filterColumn: 'operator_name', label: '操作人', width: 100 },
      { prop: 'operationTime', filterColumn: 'operation_time', label: '操作时间', width: 150, isBetween: true }
    ]
    // 默认主列表Table列
    _this.getInitTableColumns()
    _this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      let _this = this;
      loadTobaccoInfoListDataApi(_this.masterList.tableQuery).then((response) => {
        const { data } = response;
        _this.handleData(data.list || []);
        _this.masterList.tableDataTotal = data.total || 0;
      }).catch()
    },
    //新增
    addFun () {
      let _this = this;
      _this.eventType = 'add'
      _this.dialogAddEditVisible = !_this.dialogAddEditVisible
      _this.dialogAddEditTitle = '新增卷烟商品信息'
    },
    // 修改
    editFun (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要修改的卷烟商品信息', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.eventType = 'edit'
      _this.dialogAddEditVisible = !_this.dialogAddEditVisible
      _this.dialogAddEditTitle = '修改卷烟商品信息'
    },
    // 查看
    viewFun (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要查看的卷烟商品信息', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.eventType = 'view'
      _this.dialogAddEditVisible = !_this.dialogAddEditVisible
      _this.dialogAddEditTitle = '查看卷烟商品信息'
    },
    // 停用
    stopFun (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要停用的卷烟商品信息', type: 'warning' })
        return
      } else if (args[0].status === 2) {
        _this.$message({ message: '卷烟商品不在启用状态，不能停用', type: 'warning' })
        return
      }
      _this.$confirm('是否确定停用该卷烟商品信息？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        updateTobaccoInfoStatusApi({ id: args[0].id, status: 2 }).then(() => {
          _this.$message({ message: '停用成功', type: 'success' })
          _this.loadTableData()
        })
      }).catch(() => { })
    },
    // 启用
    startFun (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要启用的卷烟商品信息', type: 'warning' })
        return
      } else if (args[0].status === 1) {
        _this.$message({ message: '卷烟商品不在停用状态，不能启用', type: 'warning' })
        return
      }
      _this.$confirm('是否确定启用该卷烟商品信息？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        updateTobaccoInfoStatusApi({ id: args[0].id, status: 1 }).then(() => {
          _this.$message({ message: '启用成功', type: 'success' })
          _this.loadTableData()
        })
      }).catch(() => { })
    },
    // 导出数据API
    exportByPage () {
      let _this = this;
      exportTobaccoInfoListDataApi(_this.exportObj).then(response => {
        const { data } = response;
        _this.$store.dispatch('message/settingExportSuccess', { exportSuccess: data.createFileResult, url: data.filePath })
      })
    }
  }
}
</script>
